import {Injectable} from '@angular/core';
import {AuditEntry} from '../models/auditEntry';
import {AuditChange} from '../models/auditChange';

@Injectable()
export class AuditUtilsService {

  private fieldLabels = {
    roleGroups: 'Role',
    permissions: 'Permission',
    billingAccounts: 'Billing account',
    newEmail: 'Pending email',
    isActive: 'Active',
    isNotificationOnly: 'Notification only',
    hasDifferentDomain: 'Different domain',
    mustChangePassword: 'Must change password',
    subscribeToDocumentReport: 'Document report subscription',
    commercialOptIn: 'Commercial opt-in',
    invoicePermission: 'Invoice permission',
    thirdPartyData: 'Service provider data',
  };

  private actionLabels = {
    insert: 'Created',
    update: 'Updated',
    remove: 'Deleted',
    associate: 'Role assigned',
    dissociate: 'Role removed',
  };

  isRoleChange(entry: AuditEntry): boolean {
    return entry.action === 'associate' || entry.action === 'dissociate';
  }

  isPasswordChange(change: AuditChange): boolean {
    return change.field === 'password';
  }

  getActionLabel(action: string): string {
    return this.actionLabels[action] ?? action;
  }

  getRoleChangeLabel(entry: AuditEntry): string {
    return entry.action === 'associate' ? 'Role assignment' : 'Role removal';
  }

  getRoleName(change: AuditChange): string {
    const role = change.new ?? change.old;
    if (!role) {
      return '(unknown role)';
    }

    return this.capitalize(String(role).replace(/_/g, ' '));
  }

  getFieldLabel(field: string): string {
    return this.fieldLabels[field] ?? this.capitalize(field.replace(/([A-Z])/g, ' $1').toLowerCase().trim());
  }

  getDisplayedValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '(empty)';
    }
    if (typeof value === 'boolean') {
      return value ? 'yes' : 'no';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }

    return String(value);
  }

  private capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
